import { isReactive } from '../common-utils/signal';
import type { RenderContext } from '../render/context/createRenderContext';

export abstract class Provider {
  renderContext!: RenderContext;

  private _disposed = false;

  get disposed() {
    return this._disposed;
  }

  constructor() {}

  attach(renderContext: RenderContext): void {
    this.renderContext = renderContext;
  }

  dispose(): void {
    Object.keys(this).forEach((key) => {
      if (isReactive(this[key])) {
        this[key].dispose();
      }
    });
    this._disposed = true;
  }
}
